<template>
    <div>
        <div v-if="loanProductsLoading"
            style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;">
            <div>
                <div>
                    <h3>Getting Loans ready...</h3>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h1 class="mb-2 font-regular">Other Loans</h1>
        </div>
        <div>
            <div class="col-md-12">
                <div class="card card--no-shadow card-profile">
                    <div class="card-header">
                        <div class=" row justify-content-between">
                            <div class="col-auto">
                                <slot name="header">
                                    <h3 class="font-weight-600 mb-0 align-left">Filter Loan Report</h3>
                                </slot>
                            </div>                            
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Accoount Number</label>
                                        <input type="text" @keypress="isNumber($event)" class="form-control"
                                            v-model="account_number" placeholder="08012345678" maxlength="13" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Reference</label>
                                        <input type="text" class="form-control" placeholder="83IJDK2DHEU"
                                            v-model="ref" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button @click.prevent="allProductLoan(1)" class="button w-100 mt-2"
                                        :disabled="reportsLoading">
                                        <span class="custom-loader" v-if="reportsLoading">
                                            <loader-icon size="1.5x" class="custom-class"></loader-icon>
                                            <span style="font-weight: 600; text-transform: initial;">Fetching Loan
                                                Data...</span>
                                        </span>
                                        <span v-else>
                                            Filter
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <other-loan-table v-if="!loanProductsLoading" :loanProducts="loanProducts"
                @onPageChangeAction="onPageChange" :current="current" :total="total" />
        </div>
    </div>
</template>

<script>
import VueDataTable from "@/components/VueDataTable";
// import { mapGetters } from "vuex";
import CCard from "@/components/CCard";
import KeyValue from "../../components/KeyValue.vue";
import CModal from "@/components/CModal";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "@/services/api.service";
import Swal from "sweetalert2";
// import ErrorService from "@/services/error.service";
import CPagination from "../../components/CPagination.vue";
import ErrorService from "@/services/error.service";
// import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
// let currentTab = 0;


export default {
    components: {
        VueDataTable,
        KeyValue,
        // ClipboardIcon,
        CCard,
        CModal,
        CDataTable,
        CPagination
        // CreditCardIcon
    },
    computed: {
        permissions() {
            let permissions = this.$store.getters.permissions;
            return permissions;
        },
        // ...mapGetters(["reportsLoading"]),
        removeCommaFromAmount() {
            return this.loan_amount.toString().replace(/,/g, "");
        }
    },
    data() {
        return {
            loanProductsLoading: true,
            loanProducts: [],
            end_date: "",
            start_date: "",
            account_number: "",
            customer_id: "",
            next_page: 1,
            total: 1,
            current: 1,
            reference: "",
            bvn: "",
            phone: "",
            ref: "",
            status: "",
            reportsLoading: true,
            kpiObj: null,
            kpiLoading: false,
            createLoanModal: false,
            get_account_detail_loading: false,
            create_application_loading: false,
            account_details: null,
            states: null,
            loan_data: {
                source: "admin",
                account_name: "",
                account_number: "",
                address: "",
                city: "",
                state_id: "",
                nature_of_business: "",
                business_description: "",
                duration: "",
                payment_frequency: "",
                amount_requested: ""
            }
        };
    },
    methods: {
        checkAccountNumber(evt){
            //check if account_number is less than 10 and reset account_details
            if(this.loan_data.account_number.length < 10){
                this.account_details = null;
            }
        },
        showCreateLoanModal(item = null) {
            this.createLoanModal = true;
        },
        closeCreateModal(){
            this.createLoanModal = false;
        },
        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async allProductLoan(page) {
            this.reportsLoading = true;

            try {
                const response = await ApiService.get(
                    `loan/other/all?page=${page}&reference=${this.reference}&account_number=${this.account_number}&loan_status=active`
                );
                console.log(response);
                this.loanProducts = response.data.data.data;
                this.current = response.data.data.current_page;
                this.total = response.data.data.last_page;
                this.loanProductsLoading = false;
                this.reportsLoading = false;
            } catch (error) {
                console.log(error.response);
                this.loanProductsLoading = false;
                this.reportsLoading = false;
            } finally {
                this.loanProductsLoading = false;
                this.reportsLoading = false;
            }
        },
        onPageChange(nextp) {
            console.log(nextp + 'main component');
            if (this.current != nextp) {
                this.allProductLoan(nextp);
            }
        },
    },
    mounted() {
        this.allProductLoan(1);        
    }
};
</script>

<style>
/* Hide all steps by default: */
.step-panel {
    display: none;
}
.confirm_font{
    font-size: 11px;
    font-weight: 600;
}

</style>